import moment from 'moment'

class ImmunizationRecommendation {
  constructor (id, date, vaccineCode, pathologyId, doseNumber, status, dateCriterion) {
    this._id = id
    this._dateCriterion = dateCriterion
    this._pathologyId = pathologyId
    this._date = date
    this._vaccineCode = vaccineCode
    this._doseNumber = doseNumber
    this._status = status
  }

  get id () {
    return this._id
  }

  get dateCriterion () {
    return this._dateCriterion
  }

  get pathologyId () {
    return this._pathologyId
  }

  get date () {
    return this._date
  }

  get vaccineCode () {
    return this._vaccineCode
  }

  get doseNumber () {
    return this._doseNumber
  }

  get status () {
    return this._status
  }

  // TODO check this function. The dateCriterion will have an Array probably
  getRecommendedDate (locale = 'pt-PT') {
    return moment(new Date(this._dateCriterion.recommended)).format('L')
  }
}

export default ImmunizationRecommendation
